function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export async function registerPushSubscription(apiBase = '') {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return;

  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    const { publicKey } = await fetch(`${apiBase}/api/push/vapid-public-key`).then(r => r.json());

    const existing = await reg.pushManager.getSubscription();
    let subscription = existing;
    if (!existing) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    const token = localStorage.getItem('paper_work_token');
    await fetch(`${apiBase}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ subscription }),
    });
  } catch (e) {
    console.warn('push subscription failed:', e.message);
  }
}

export async function unregisterPushSubscription(apiBase = '') {
  try {
    const token = localStorage.getItem('paper_work_token');
    await fetch(`${apiBase}/api/push/subscribe`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    const sub = await reg?.pushManager.getSubscription();
    await sub?.unsubscribe();
  } catch {}
}
